<template>
  <a-modal
    :visible="visible"
    :width="500"
    title="新增项目"
    :footer="null"
    @cancel="$emit('cancel')"
  >
    <a-spin :spinning="spinning">
      <a-form :form="form" v-bind="formItemLayout" @submit="handlePost">
        <a-form-item label="开标地区">
          <a-select
            v-decorator="[
              'loc_id',
              {
                rules: [{ required: true, message: '请选择开标地区' }],
              },
            ]"
            placeholder="请选择"
            @change="setLoc"
          >
            <a-select-option v-for="(item, index) in locs" :key="index" :value="item.id">{{
              item.name
            }}</a-select-option>
          </a-select> </a-form-item
        >
        <a-form-item label="模板">
          <a-select
            v-decorator="[
              'temp_id',
              {
                rules: [{ required: true, message: '请选择模板' }],
              },
            ]"
            placeholder="请选择"
            @change="changeTemp"
          >
            <a-select-option v-for="(item, index) in tempList" :key="index" :value="item.id">{{
              item.name
            }}</a-select-option>
          </a-select>
        </a-form-item>
        <!-- <a-form-item label="招标文件">
          <a-input
            v-show="false"
            v-decorator="[
              'bidding_file',
              { rules: [{ required: true, message: '请上传招标文件' }] },
            ]"
          ></a-input>
          <FileUpload
            @upload="biddingUpload"
            accept="application/pdf,image/jpeg,image/png,.docx,.doc,.xlsx,.xls"
          ></FileUpload>
        </a-form-item> -->
        <a-form-item label="项目文件">
          <a-input
            v-show="false"
            v-decorator="[
              'project_file_ids',
              { rules: [{ required: true, message: '请上传项目文件' }] },
            ]"
          ></a-input>
          <MultFileUpload
            @upload="projectFileUpload"
            accept="application/pdf,image/jpeg,image/png,.docx,.doc,.xlsx,.xls"
          ></MultFileUpload>
        </a-form-item>
        <a-form-item label="项目名称">
          <a-textarea
            v-decorator="['name', { rules: [{ required: true, message: '请输入项目名称' }] }]"
            autoSize
          ></a-textarea>
        </a-form-item>
        <a-form-item label="项目编号">
          <a-textarea v-decorator="['record_no']" autoSize></a-textarea>
        </a-form-item>
        <a-form-item label="受益人">
          <a-textarea
            v-decorator="['proprietor', { rules: [{ required: true, message: '请输入受益人' }] }]"
            autoSize
          ></a-textarea>
        </a-form-item>
        <a-form-item label="开标日期">
          <a-date-picker
            v-decorator="[
              'bidder_timef',
              { rules: [{ required: true, message: '请选择开标日期' }] },
            ]"
            class="w-full"
            format="YYYY-MM-DD HH:mm:ss"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            show-time
          />
        </a-form-item>
        <a-form-item label="担保额度" :help="info.money > 0 ? convertCurrency(info.money) : ''">
          <a-input-number
            v-decorator="['money', { rules: [{ required: true, message: '请输入担保额度' }] }]"
            :min="0"
            style="width: 100%"
            @change="moneychange"
          />
        </a-form-item>
        <template v-if="tempds">
          <template v-for="(tempd, index) in tempds">
            <a-form-item
              v-if="tempd.is_show"
              :key="index"
              :label="tempd.name"
              :required="tempd.is_required"
            >
              <a-textarea autoSize v-if="tempd.is_text_area === 1" v-model="tempd.value" />
              <a-input v-else-if="tempd.is_text_area === 0" v-model="tempd.value" />
              <a-date-picker
                v-else
                format="YYYY年M月D日"
                v-model="tempd.value"
                class="w-full"
                valueFormat="YYYY年M月D日"
              />
            </a-form-item>
          </template>
        </template>
        <a-form-item :wrapperCol="{ span: 14, offset: 6 }">
          <a-button class="mr-6" type="primary" size="default" html-type="submit"> 提交</a-button>
          <a-button size="default" @click="$emit('cancel')">取消</a-button></a-form-item
        >
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
  import { convertCurrency } from '@/utils/transContent';
  import { temps } from '@/api/temp';
  import { project_locs, projectSave } from '@/api/project';
  // import FileUpload from '@/components/FileUpload/index';
  import MultFileUpload from '@/components/MultFileUpload/index';
  export default {
    components: {
      // FileUpload,
      MultFileUpload
    },
    props: {
      visible: Boolean,
    },
    data() {
      return {
        formItemLayout: {
          labelCol: { span: 6 },
          wrapperCol: { span: 14 },
        },
        form: this.$form.createForm(this, { name: 'company' }),
        // tempCates: [],
        info: { temp_category_id : 2, effect_month: 12 },
        spinning: false,
        locs: [],
        tempList: [],
        tempds: [],
        loading: false,
      };
    },
    async mounted() {
      // this.getTempCates();
      this.locs = (await project_locs({ current: -1 })).data;
    },
    watch: {
      async visible(a) {
        if (a) {
          setTimeout(() => this.form.resetFields(), 1);
          this.info = { temp_category_id : 2, effect_month: 12 };
          // await this.getTempCates();
        }
      },
    },
    methods: {
      convertCurrency,
      // async getTempCates() {
      //   this.tempCates =
      //     (
      //       await temp_categorys({
      //         current: -1,
      //         qp: JSON.stringify({ eq: { review: 1 } }),
      //         orderby: 'a.sort desc',
      //       })
      //     ).data || [];
      //   console.log(this.tempCates);
      // },
      // changeCate(e) {
      //   this.info.temp_category_id = e;
      //   this.form.resetFields(['loc_id', 'temp_id']);
      //   this.getTemps(e);
      // },
      setLoc(e) {
        this.info.loc_id = e;
        this.form.resetFields(['temp_id']);
        this.getTemps();
      },
      moneychange(e) {
        console.log(e);
        this.info.money = e;
      },
      async getTemps(value) {
        let qp = {
          eq: {
            category_ids: 2,
            review: 1,
          },
        };
        if (this.info.loc_id > 0) {
          qp.eq.loc_id = this.info.loc_id;
        }
        this.tempList = (
          await temps({
            current: -1,
            qp: JSON.stringify(qp),
            is_only_user: 1,
          })
        ).data;
      },
      changeTemp(tempid) {
        let record = this.tempList.find((e) => {
          return e.id == tempid;
        });
        this.info.temp = record;
        this.tempds = record.temp_ds || [];
        this.info.rate = record.rate;
        this.info.auto_review = record.auto_review;
        this.info.content = record.content;
        this.info.content_2 = record.content_2;
        this.info.lowest_poundage = record.lowest_poundage;
      },
      // async biddingUpload(res) {
      //   try {
      //     this.info.bidding_file = res.pathname;
      //     this.info.bidding_file_id = res.id;
      //     this.info.bidding_file_name = res.filename;
      //     setTimeout(() => this.form.setFieldsValue({ bidding_file: res.pathname }), 1);
      //   } catch (error) {
      //     this.$message.error(error);
      //   }
      // },
      projectFileUpload(res) {
        this.info.project_file_ids = res
          .map((v) => {
            return v.uid;
        })
        .join(',');
        setTimeout(() => this.form.setFieldsValue({ project_file_ids: this.info.project_file_ids }), 1);
        console.log("project_file_ids:"+this.info.project_file_ids);
      },
      // async zbUpload(res) {
      //   try {
      //     this.info.zb_file = res.pathname;
      //     this.info.zb_file_id = res.id;
      //     this.info.zb_file_name = res.filename;
      //     setTimeout(() => this.form.setFieldsValue({ zb_file: res.pathname }), 1);
      //   } catch (error) {
      //     this.$message.error(error);
      //   }
      // },
      async handlePost(e) {
        e.preventDefault();
        this.form.validateFieldsAndScroll(async (err, values) => {
          if (!err) {
            for (let i = 0; i < this.tempds.length; i++) {
              const v = this.tempds[i];
              if (v.is_required && !v.value) {
                this.$message.warning('请输入' + v.name);
                return;
              }
            }
            try {
              this.spinning = true;
              let data = Object.assign(this.info, values);
              data.effect_month = 12;
              data.temp_d = this.tempds;
              let pay = (data.rate * data.money * data.effect_month) / 1200;
              pay = parseFloat(pay.toFixed(0));
              let poundage = pay > this.info.temp.money ? pay : this.info.temp.money;
              data.poundage = poundage;
              await projectSave(data);
              this.$emit('ok', data);
            } catch (error) {
              this.$error({ title: '错误提示', content: error });
            } finally {
              this.$emit('cancel');
              this.spinning = false;
            }
          } else {
            console.log(values);
          }
        });
      },
    },
  };
</script>
<style scoped lang="less">
  :deep(.ant-row) {
    position: static;
  }
</style>
